import styled from "styled-components";
import {ReactNode} from "react";

interface Props {
	landscape?: boolean;
	printSmall?: boolean;
	children?: ReactNode;
}

const PrintWrap = styled.div<{landscape?: boolean; printSmall?: boolean}>`
	@page {
		size: ${props => (props.landscape ? "A4 landscape" : "A4")};
	}

	@media print {
		width: 210mm;
		height: auto;
	}
`;

const PrintArea = styled.div`
	@media print {
		display: block;
		width: 100%;
		height: auto !important;
		margin: 0;
		padding: 0;
		overflow-y: hidden !important;
		break-after: auto;
		page-break-after: auto;
		-webkit-print-color-adjust: exact;
		strong,
		p,
		label,
		ul li {
			font-size: var(--medium-size);
		}
		em {
			font-size: var(--medium-size);
		}
		h4 {
			font-size: var(--large-size);
		}
		table {
			width: 100%;
			border-top-width: 1px;
			border-top-style: solid;
			border-top-color: var(--emp-color);
			th {
				height: 50px !important;
				background-color: var(--disabled-color) !important;
				-webkit-print-color-adjust: exact;
			}
			td {
				padding: 10px 20px;
			}
			th,
			td {
				font-size: var(--medium-size);
				word-break: keep-all;
				p {
					font-size: var(--basic-size);
				}
			}
		}
	}
`;

const NoPrintArea = styled.div`
	@media print {
		display: none;
	}
`;

const Print = ({landscape, printSmall, children}: Props) => (
	<PrintWrap landscape={landscape} printSmall={printSmall}>
		{children}
	</PrintWrap>
);

export {PrintArea, NoPrintArea};

export default Print;
